import { ChevronDown, ChevronRight, Info } from 'lucide-react';
import React, { useState } from 'react';
import './CollapsibleInfoBlock.css';

interface CollapsibleInfoBlockProps {
  title: string;
  items: string[];
  defaultCollapsed?: boolean;
}

export const CollapsibleInfoBlock: React.FC<CollapsibleInfoBlockProps> = ({
  title,
  items,
  defaultCollapsed = true,
}) => {
  const [isOpen, setIsOpen] = useState(!defaultCollapsed);

  return (
    <div className="collapsible-info-block">
      <button
        type="button"
        className="collapsible-info-block__header"
        onClick={() => setIsOpen((o) => !o)}
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Collapse' : 'Expand'}
      >
        <span className="collapsible-info-block__icon-wrap">
          <Info size={18} className="collapsible-info-block__icon" />
        </span>
        <span className="collapsible-info-block__title">{title}</span>
        {isOpen ? (
          <ChevronDown size={20} className="collapsible-info-block__chevron" />
        ) : (
          <ChevronRight size={20} className="collapsible-info-block__chevron" />
        )}
      </button>
      {isOpen && (
        <ul className="collapsible-info-block__list">
          {items.map((text, i) => (
            <li key={i}>{text}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
